import React, { Component } from "react"
import Clipboard from "clipboard"
import PropTypes from "prop-types"
import { ShareButtons } from 'react-share'
import { MEMBERS_FRONTEND_URL } from '../../utils/helpers/constanteData'

const { FacebookShareButton, TwitterShareButton } = ShareButtons

class ParrainLink extends Component {
  static propTypes = {
    userCode: PropTypes.string.isRequired,
    userName: PropTypes.string.isRequired,
  }

  render() {
    const { userCode, userName } = this.props
    let linkShare = `${MEMBERS_FRONTEND_URL}/pr/${userCode}`
    let titleShare = `Test Votre lien de parrainage de APS Bénin: ${linkShare}`

    let clipboard = new Clipboard('.parrain-form-btn-copied', {
      target: function() {
        return document.querySelector('.aps-dashboard-container-form-input-check-link');
      }
    });
    clipboard.on('success', function(e) {
        document.querySelector(".parrain-form-btn-copied").innerHTML = "Copié";
        document.querySelector(".parrain-form-btn-copied").className += " parrain-form-btn-paste";
    });

    clipboard.on('error', function(e) {
      document.querySelector(".parrain-form-btn-copied").innerHTML = "Erreur";
      document.querySelector(".parrain-form-btn-copied").className += "parrain-form-btn-error";
    });

    return (
      <div className="aps-dashboard-body-second-parrain-content">
        <h1 className="uk-text-center aps-dashboard-body-stats-title">{userName} votre lien de parrainage est prêt !</h1>
        <div className="uk-text-center aps-section-parrain-content-dashboard">
          Vous pouvez le partager dès maintenant avec vos amis et gagner des primes.
        </div>
        <div className="uk-child-width-1-2@m aps-dashboard-container-form" data-uk-grid>
          <div className="aps-dashboard-container-form-first">
            <p className="aps-dashboard-container-form-input-check-link">
              {linkShare}
            </p>
          </div>
          <div className="aps-dashboard-container-form-second">
            <a className="uk-button aps-dashboard-container-form-btn-copied parrain-form-btn-copied">Copier</a>
          </div>
        </div>
        <div className="uk-text-center aps-section-parrain-content-social-network-dashboard">
          Partager sur les réseaux sociaux
        </div>

        <div className="uk-text-center">
          <FacebookShareButton
            url={linkShare}
            quote={titleShare}
            className="uk-button aps-dashboard-container-form-btn-social-network aps-dashboard-container-form-btn-social-network-facebook"
          >
            <span className="aps-icon-parrain-dashboard" data-uk-icon="icon: facebook"></span>facebook
          </FacebookShareButton>

          <TwitterShareButton
            url={linkShare}
            title={titleShare}
            className="uk-button aps-dashboard-container-form-btn-social-network aps-dashboard-container-form-btn-social-network-twitter"
          >
            <span className="aps-icon-parrain-dashboard" data-uk-icon="icon: twitter"></span>twitter
          </TwitterShareButton>
        </div>
      </div>
    )
  }
}
export default ParrainLink



// WEBPACK FOOTER //
// ./src/components/ParrainLink/index.js